<template>
  <div :class="{ 'produce-source': true, single: single }">
    {{ produceSource }}
  </div>
</template>

<script>
export default {
  props: {
    sku: {
      type: Object,
      default: () => {}
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    produceSource() {
      const produceSource = this.sku?.skuIntroduce?.produceSource || ''
      return produceSource
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.produce-source {
  margin-top: 8px;
  margin-left: 148px;
  padding: 4px 8px;
  line-height: 16px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  border-radius: 4px;
  @include text-overflow-ellipsis;
  @include text(12px, #8c8c8c);
}
.single {
  margin-top: 4px;
}
</style>
